import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { TreeData } from 'element-ui/types/tree';

import { types } from './types';
import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		VyrobekVoz: [],
		Vyrobeknd: [],
		Mena: [],
		LanguageId: [],
		Pokladna: [],
		VinsubstrnvRez: [],
		VinsubstrovRez: [],
		VinsubstrsmRez: [],
		MnrsubstrnvRez: [],
		MnrsubstrovRez: [],
		MnrsubstrsmRez: [],
		SpzsubstrnvRez: [],
		SpzsubstrovRez: [],
		SpzsubstrsmRez: [],
		SkladOzn: [],
		SkladNv: [],
		SkladOv: [],
		PujcovnaId: [],
		ZakazkaDruh: [],
		OZakazkaPzn: [],
		SkladpneuOzn: [],
		SkladnvOznKonsign: [],
		Skladost: [],
		JfndZpracrezimPzn: [],
		ZakazkaDruhEshop: [],
		ZakazkaDruhPz: [],
		UctoosnovaId: [],
	},
	edit: {
		PracovnikId: null as number | null,
		PracovnikIdText: null as string | null,
		PracovnikOsobniCis: null as string | null,
		Login: null as string | null,
		PerskartaId: null as string | null,
		ProvozovnaId: null as number | null,
		ProvozovnaIdText: null as string | null,
		StrednaklOzn: null as number | null,
		StrednaklOznText: null as string | null,
		VyrobekvozOzn: null as string | null,
		VyrobekndOzn: null as string | null,
		MechanikId: null as number | null,
		MechanikIdText: null as string | null,
		MechanikOsobniCis: null as string | null,
		MenaId: null as number | null,
		PokladnaId: null as number | null,
		TympracId: null as number | null,
		TympracIdText: null as string | null,
		TympracIdPt: null as number | null,
		TympracIdPtText: null as string | null,
		LanguageId: null as number | null,
		ZakazkaLeaszakaznikPrp: null as boolean | null,
		ZakazkaPojistovnaPrp: null as boolean | null,
		ZakazkaPripravaPrp: null as boolean | null,
		ExtodpisZobr: null as number | null,
		VyrobekndVydejPrp: null as boolean | null,
		ZakazzobrPrp: null as boolean | null,
		DmscVinFormatPrp: null as boolean | null,
		PultndzrychPrp: null as boolean | null,
		SkillLevel: null as number | null,
		ZakazmojePrp: null as boolean | null,
		VinsubstrnvRez: null as number | null,
		VinsubstrovRez: null as number | null,
		VinsubstrsmRez: null as number | null,
		SpzsubstrnvRez: null as number | null,
		SpzsubstrovRez: null as number | null,
		SpzsubstrsmRez: null as number | null,
		MnrsubstrnvRez: null as number | null,
		MnrsubstrovRez: null as number | null,
		MnrsubstrsmRez: null as number | null,
		SkladOzn: null as number | null,
		SkladnvOzn: null as number | null,
		SkladovOzn: null as number | null,
		ZakazkaDruh: null as string | null,
		OzakazkaPzn: null as number | null,
		PujcovnaId: null as number | null,
		SkladpneuOzn: null as number | null,
		SkladnvOznKonsign: null as number | null,
		SkladostOzn: null as number | null,
		JfndZpracrezimPzn: null as number | null,
		ZakazkaDruhEshop: null as string | null,
		ZakazkaDruhPz: null as string | null,
		RekltxtId: null as number | null,
		RekltxtIdText1: null as string | null,
		RekltxtIdText2: null as string | null,
		RekltxtIdNv: null as number | null,
		RekltxtIdNvText1: null as string | null,
		RekltxtIdNvText2: null as string | null,
		ZlTextvoln: null as string | null,
		BarvaEdit: null as number | null,
		GridBcolorAttention: null as number | null,
		GridBcolorCritical: null as number | null,
		GridBcolorInactive: null as number | null,
		GridBcolorReady: null as number | null,
		GridBcolorUrgent: null as number | null,
		GridFcolorUnchecked: null as number | null,
		UctoosnovaId: null as number | null,
		C1: null as string | null,
		C2: null as string | null,
		EditDat: null as string | null,
		EditPracId: null as number | null,
		HesloEditDat: null as string | null,
		SuperuzivPrp: null as boolean | null,
		VstupDat: null as string | null,
		VstupPracId: null as number | null,
		ZaznamId: null as number | null,
		UserMessageList: [] as { Title: string, Message: string, Type: number }[],
		AliasKategs: [],
		PrizPrava: [],
		NeprizPrava: [],
		PartItemVal: null as number | null,
		PartItemPer: null as number | null,
		PartItemTotalVal: null as number | null,
		PartItemTotalPer: null as number | null,
		LaborItemVal: null as number | null,
		LaborItemPer: null as number | null,
		LaborItemTotalVal: null as number | null,
		LaborItemTotalPer: null as number | null,
		OrderTotalVal: null as number | null,
		OrderTotalPer: null as number | null,
		SelectedMenu: [],
		UnSelectedMenu: [],
		MainMenus: [],
		SubMenus: [],
		MenuOperations: [],
		MenuTabs: [],
		DefaultOperations: [],
		DefaultTabs: [],
		SelectedOperations: [],
		SelectedTabs: [],
		SelectedTabsAccess: []
	},
	depTableNames: [],
	depTableSettings: {},
	localState: {
		permissionsTree: [] as { AliasKategId: number, AliasId: number, Text: string, children: TreeData[] }[],
		dataChecked: [] as number[],
		menuTree: [] as { Id: number, SubMenuId: number, Text: string, children: any[] }[],
		subMenuTree: [] as { Id: number, SubMenuId: number, Text: string, children: TreeData[] }[],
		selectedOperations: [] as number[],
		selectedTabs: [] as number[],
		selectedTabsAccess:[] as number[],
		selectedOriginalOperations: [] as number[],
		selectedOriginalTabs: [] as number[],
		menuOperations: [] as { Id: number, SubMenuId: number, Text: string, children: TreeData[] }[],
		menuTabs: [] as { Id: number, SubMenuId: number, Text: string, children: TreeData[] }[],
	},
	extraActions: {
		[types.actions.GET_UZIVATEL_PERM]: async ({ state, commit, dispatch }) => {
			const { data } = await apiProvider.getPracovnikPrava(state.edit.PracovnikId!);
			commit(types.mutations.GET_PERM, data);
			state.edit.NeprizPrava = data.NeprizPrava;
			state.edit.PrizPrava = data.PrizPrava;
			state.edit.AliasKategs = data.AliasKategs;
			state.edit.MainMenus = data.MainMenus;
			state.edit.UnSelectedMenu = data.UnSelectedMenu;
			state.edit.SelectedMenu = data.SelectedMenu;
			state.edit.MainMenus = data.MainMenus;
			state.edit.SubMenus = data.SubMenus;
			state.edit.MenuOperations = data.MenuOperations;
			state.edit.MenuTabs = data.MenuTabs;
			state.edit.DefaultOperations = data.DefaultOperations;
			state.edit.DefaultTabs = data.DefaultTabs;
			state.edit.SelectedOperations = data.SelectedOperations;
			state.edit.SelectedTabs = data.SelectedTabs;
			state.edit.SelectedTabsAccess = data.SelectedTabsAccess;
		},
		[types.actions.SAVE_PERM]: async ({ state, commit, dispatch }, data) => {
			try {
				state.loadingCount += 1;
				await apiProvider.saveUserPermissions(state.edit.PracovnikId!, data);
				await dispatch(types.actions.GET_UZIVATEL_PERM);
			} finally {
				state.loadingCount -= 1;
			}
		},
	},
	extraGetters: {},
	extraMutations: {
		[types.mutations.REKLAMNI_TEXTY_MAPPER](state, { data }) {
			state.edit.RekltxtId = data.id;
			state.edit.RekltxtIdText1 = data.text1;
			state.edit.RekltxtIdText2 = data.text2;
		},
		[types.mutations.REKLAMNI_TEXTY_NV_MAPPER](state, { data }) {
			state.edit.RekltxtIdNv = data.id;
			state.edit.RekltxtIdNvText1 = data.text1;
			state.edit.RekltxtIdNvText2 = data.text2;
		},
		[types.mutations.GET_PERM](state, data) {
			state.edit.NeprizPrava = data.NeprizPrava;
			state.edit.PrizPrava = data.PrizPrava;
			state.edit.AliasKategs = data.AliasKategs;
		},
		[types.mutations.NAKLADOVE_STREDISKO_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
		},
		[types.mutations.MECHANIK_MAPPER](state, { data }) {
			state.edit.MechanikId = data.value;
			state.edit.MechanikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.edit.MechanikOsobniCis = data.osobniCis;
		},
		[types.mutations.PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.edit.PracovnikId = data.value;
			state.edit.PracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.edit.PracovnikOsobniCis = data.osobniCis;
		},
		[types.mutations.TYM_PRAC_MAPPER](state, { data }) {
			state.edit.TympracId = data.value;
			state.edit.TympracIdText = data.text;
		},
		[types.mutations.TYM_PRAC_PT_MAPPER](state, { data }) {
			state.edit.TympracId = data.value;
			state.edit.TympracIdPtText = data.text;
		},
	},
	props: {
		mode: null,
	},
});
